var React = require('react');

function Stethoscope60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M52 41.942v3.912c0 8.856-6.707 14.145-17.94 14.145-9.457 0-16.06-7.365-16.06-17.91 0-.019.01-.035.011-.054-.001-.018-.011-.034-.011-.053v-4.049C5.546 36.52 0 9.056 0 5.2 0 .525 6.65.027 6.934.007c.56-.008 1.026.38 1.063.93a1.004 1.004 0 0 1-.929 1.067C7.018 2.007 2 2.388 2 5.2c0 3.429 5.674 30.801 17 30.801S36 8.629 36 5.2c0-2.78-5.016-3.193-5.066-3.196a1.003 1.003 0 0 1-.932-1.065c.037-.551.526-.94 1.064-.932C31.35.027 38 .525 38 5.2c0 3.856-5.546 31.319-18 32.733v4.049c0 .019-.01.035-.011.053.001.019.011.035.011.054C20 51.457 25.781 58 34.06 58 38.852 58 50 56.815 50 45.854v-3.912c-4.493-.499-8-4.316-8-8.94 0-4.962 4.037-8.999 8.999-8.999 4.963 0 9.001 4.037 9.001 8.999 0 4.624-3.507 8.44-8 8.94zm-1.001-15.94c-3.859 0-6.999 3.141-6.999 7a7.007 7.007 0 0 0 6.999 6.999c3.86 0 7.001-3.14 7.001-6.999 0-3.859-3.141-7-7.001-7z","key":1})]);
}

Stethoscope60px.displayName = "Stethoscope60px";

Stethoscope60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 60 60"};

module.exports = Stethoscope60px;

Stethoscope60px.default = Stethoscope60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/stethoscope-60px.svg
// module id = 1216
// module chunks = 0